import { render, staticRenderFns } from "./appr-casing.vue?vue&type=template&id=1f0bff02&scoped=true"
import script from "./appr-casing.vue?vue&type=script&lang=js"
export * from "./appr-casing.vue?vue&type=script&lang=js"
import style0 from "./appr-casing.vue?vue&type=style&index=0&id=1f0bff02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0bff02",
  null
  
)

export default component.exports